import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export default class GetPageDataAdvertisingUseCase extends UseCase {
  constructor({config, fromRawDataToAdvertisingValueObjectMapper}) {
    super()

    this._fromRawDataToAdvertisingVOMapper = fromRawDataToAdvertisingValueObjectMapper
    this._config = config
    this._defaultSearch = this._config.get('search').DEFAULT_SEARCH
  }

  @tracer({metric: 'GetPageDataAdvertisingUseCase#execute'})
  @inlineError
  execute({
    ad,
    adType,
    bodyType,
    category,
    fuelType,
    make,
    model,
    pageName,
    search = this._defaultSearch,
    searchTerm,
    section,
    seller,
    tag
  }) {
    const advertisingVO = this._fromRawDataToAdvertisingVOMapper.map({
      ad,
      adType,
      bodyType,
      category,
      fuelType,
      make,
      model,
      pageName,
      search,
      searchTerm,
      section,
      seller,
      tag
    })

    return Promise.resolve(advertisingVO.toJSON())
  }
}
